// Copyright 2019 Istio Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function handleThemes(): void {
    // reapply this in case the first call didn't 'stick' due to timing
    applyStyleSheet(currentTheme);

    listen(getById(lightThemeItem), click, () => {
        applyStyleSheet(lightTheme);
        localStorage.setItem(themeStorageItem, lightTheme);
        return false;
    });

    listen(getById(darkThemeItem), click, () => {
        applyStyleSheet(darkTheme);
        localStorage.setItem(themeStorageItem, darkTheme);
        return false;
    });
}

handleThemes();
